<template>
  <div class="documents">
    <span v-if="invoiceNumber" class="doc-chip" title="Facture">FA{{ format(invoiceNumber) }}</span>
    <span v-if="depositNumber" class="doc-chip" title="Acompte">AC{{ format(depositNumber) }}</span>
    <span v-for="number in creditNoteNumbers" :key="number" class="doc-chip" title="Avoir">AV{{ format(number) }}</span>
  </div>
</template>

<script>
export default {
  name: 'DocumentChips',
  props: {
    invoiceNumber: {type: Number, default: undefined},
    depositNumber: {type: Number, default: undefined},
    creditNoteNumbers: {type: Array, default: () => []},
  },
  methods: {
    format(number) {
      return number.toString().padStart(4, '0');
    },
  },
};
</script>

<style lang="stylus" scoped>
.documents
  display flex
  flex-wrap wrap
  align-items center
  gap 4px

.doc-chip
  padding 0 6px
  border-radius 5px
  font-size 0.8em
  font-weight 600
  line-height 1.6
  background-color #f0f1f3
  color #6b7076
</style>
